import React, { PropsWithChildren } from 'react';
import { canShareNatively, SocialMediaShareData, toNativeShareData } from 'utils/socials';
import { NativeShareButton } from '../Button/NativeShareButton';
import { CustomShareButton } from '../Button/CustomShareButton';
import { ShareIcon } from 'icons/share';
import { Button } from '../Button/Button';

// This is a hacky check for mobile that we're using to determine whether or
// not to show the native share menu. Windows 11 has a native share menu
// that we DO NOT want to show. See DBWEB-650
const isMobile_DO_NOT_RE_USE = () => {
  return window.innerWidth <= 768;
};

export function ShareDropdownButton({
  data,
  children,
  text,
}: PropsWithChildren<ShareDropdownButtonProps>) {
  // We don't want a platform-specific dropdown if we can just
  // natively share target data.
  if (canShareNatively(data) && isMobile_DO_NOT_RE_USE()) {
    // This also includes copying the OpenSea link as that's part of native sharing
    return <NativeShareButton data={toNativeShareData(data)} text={text} />;
  }

  if (text) {
    return (
      <>
        <Button xsmall fullWidth>
          <ShareIcon /> {text}
        </Button>
        {children}
      </>
    );
  }

  return (
    <>
      <CustomShareButton />
      {children}
    </>
  );
}

export type ShareDropdownButtonProps = {
  data: SocialMediaShareData;
  text?: string;
};
